import React, { useEffect, useState } from "react";
import { useCart } from "layouts/ecommerce/CartContext";
import axios from "axios";
import {
  Card,
  CardActionArea,
  CardMedia,
  CardContent,
  Typography,
  CardActions,
  TextField,
  Dialog,
  DialogTitle,
  DialogActions,
  Button,
  Grid,
  DialogContent,
} from "@mui/material";
import PropTypes from "prop-types";
import MDButton from "components/MDButton";
import MDBox from "components/MDBox";
import MDTypography from "components/MDTypography";
import BASE_URL from "config/Base_URL";

export default function MultiActionAreaCard({ search }) {
  const [listProduk, setListProduk] = useState([]);
  const token = sessionStorage.getItem("token");

  const { addToCart } = useCart();

  const [openModal, setOpenModal] = useState(false);
  const [selectedProduct, setSelectedProduct] = useState(null);
  const [qty, setQty] = useState(1);

  const handlePesan = (item) => {
    setSelectedProduct(item);
    setQty(1);
    setOpenModal(true);
  };

  const handleAddCart = () => {
    addToCart(selectedProduct, qty);
    setOpenModal(false);
  };

  const formatRupiah = (number) => {
    if (!number) return "";
    return new Intl.NumberFormat("id-ID", {
      style: "currency",
      currency: "IDR",
      minimumFractionDigits: 0,
    }).format(number);
  };

  useEffect(() => {
    fetchProducts();
  }, []);

  const fetchProducts = async () => {
    try {
      const response = await axios.get(`${BASE_URL}/products`, {
        headers: {
          Authorization: `Bearer ${token}`,
        },
      });
      setListProduk(response.data.data);
    } catch (error) {
      console.error("Gagal menampilkan produk:", error);
    }
  };

  // 🔎 FILTER PRODUK SESUAI SEARCH
  const filteredProduk = listProduk.filter((item) =>
    (item.name || item.nama_produk || "").toLowerCase().includes((search || "").toLowerCase())
  );

  // const filteredProduk = listProduk.filter((item) => matchSearch(item, search));
  return (
    <>
      <Grid container spacing={3}>
        {filteredProduk.map((item, index) => (
          <Grid item xs={6} sm={4} md={3} lg={2.4} key={item.id || index}>
            <Card
              sx={{
                maxWidth: "100%",
                height: "100%",
                display: "flex",
                flexDirection: "column",
                borderRadius: "12px",
                boxShadow: "0 4px 12px rgba(0,0,0,0.08)",
                transition: "all 0.3s ease",
                "&:hover": {
                  transform: "translateY(-8px)",
                  boxShadow: "0 12px 24px rgba(0,0,0,0.15)",
                },
              }}
            >
              <MDBox sx={{ position: "relative" }}>
                <CardMedia
                  component="img"
                  image={`${BASE_URL}/images/${item.picture}`}
                  alt={item.name || item.nama_produk || "Product Image"}
                  sx={{
                    objectFit: "cover",
                    borderTopLeftRadius: "12px",
                    borderTopRightRadius: "12px",
                    width: "100%",
                    aspectRatio: "1/1",
                  }}
                />
              </MDBox>

              <CardContent sx={{ flexGrow: 1, p: 2.5 }}>
                <MDTypography
                  gutterBottom
                  variant="h6"
                  component="div"
                  sx={{
                    fontWeight: 700,
                    fontSize: "1.1rem",
                    mb: 1.5,
                    minHeight: "3em",
                    display: "-webkit-box",
                    WebkitLineClamp: 2,
                    WebkitBoxOrient: "vertical",
                    overflow: "hidden",
                  }}
                >
                  {item.name || item.nama_produk}
                </MDTypography>

                <MDTypography
                  variant="body2"
                  color="text.secondary"
                  sx={{
                    mb: 2,
                    display: "-webkit-box",
                    WebkitLineClamp: 3,
                    WebkitBoxOrient: "vertical",
                    overflow: "hidden",
                  }}
                >
                  {item.description || item.deskripsi}
                </MDTypography>
              </CardContent>

              <MDBox sx={{ p: 2.5, pt: 0, display: "flex", flexDirection: "column" }}>
                <MDBox sx={{ display: "flex", alignItems: "center", mb: 1.5 }}>
                  <MDTypography variant="h6" color="success" sx={{ fontWeight: 800 }}>
                    {formatRupiah(item.price)}
                  </MDTypography>
                  <MDTypography variant="caption" color="text.secondary" sx={{ ml: "auto" }}>
                    Unit: {item.unit}
                  </MDTypography>
                </MDBox>

                <MDButton
                  fullWidth
                  variant="contained"
                  color="success"
                  onClick={() => handlePesan(item)}
                >
                  Pesan Sekarang
                </MDButton>
              </MDBox>
            </Card>
          </Grid>
        ))}
        {filteredProduk.length === 0 && (
          <MDTypography sx={{ m: 3 }}>Produk tidak ditemukan.</MDTypography>
        )}
      </Grid>

      {/* MODAL */}
      <Dialog open={openModal} onClose={() => setOpenModal(false)}>
        <DialogTitle>Tambah ke Keranjang</DialogTitle>
        <DialogContent>
          <MDTypography variant="h6">{selectedProduct?.name}</MDTypography>

          <TextField
            label="Jumlah"
            type="number"
            fullWidth
            sx={{ mb: 1 }}
            inputProps={{
              min: 0.01,
              step: 0.01,
              pattern: "^[0-9]+(\\.[0-9]{1,2})?$",
            }}
            value={qty}
            onChange={(e) => {
              const value = e.target.value;
              const regex = /^\d*\.?\d{0,2}$/;
              if (value === "" || regex.test(value)) {
                setQty(value === "" ? 0.01 : parseFloat(value));
              }
            }}
            onBlur={() => {
              if (qty < 0.01 || isNaN(qty)) {
                setQty(0.01); // minimal 0.01
              } else {
                setQty(parseFloat(qty.toFixed(2)));
              }
            }}
          />
        </DialogContent>
        <DialogActions>
          <Button onClick={() => setOpenModal(false)}>Batal</Button>
          <Button variant="contained" color="success" onClick={handleAddCart}>
            Tambah
          </Button>
        </DialogActions>
      </Dialog>
    </>
  );
}

MultiActionAreaCard.propTypes = {
  search: PropTypes.string,
};
